var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 7.6999L11 5.3999V14.9999C11 15.5999 11.4 15.9999 12 15.9999C12.6 15.9999 13 15.5999 13 14.9999V5.3999L15.3 7.6999C15.7 8.0999 16.3 8.0999 16.7 7.6999C17.1 7.2999 17.1 6.6999 16.7 6.2999L12.7 2.2999C12.6 2.1999 12.5 2.0999 12.4 2.0999C12.2 1.9999 11.9 1.9999 11.6 2.0999C11.5 2.0999 11.4 2.1999 11.3 2.2999L7.3 6.2999C6.9 6.6999 6.9 7.2999 7.3 7.6999C7.7 8.0999 8.3 8.0999 8.7 7.6999ZM21 13.9999C20.4 13.9999 20 14.3999 20 14.9999V18.9999C20 19.5999 19.6 19.9999 19 19.9999H5C4.4 19.9999 4 19.5999 4 18.9999V14.9999C4 14.3999 3.6 13.9999 3 13.9999C2.4 13.9999 2 14.3999 2 14.9999V18.9999C2 20.6999 3.3 21.9999 5 21.9999H19C20.7 21.9999 22 20.6999 22 18.9999V14.9999C22 14.3999 21.6 13.9999 21 13.9999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.12336eecfb8928fb6dc967fa44742f73.svg";
export { ForwardRef as ReactComponent };